export const Data = [
  {
    type: "zh",
    imgList: [
      {
        src:"https://www.victrum.com/image/tp/微创首页banner.png"
      }
      // {
      //   src: "/Users/liuwei/yk/img",
      // }
      // , {
      //   src: "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
      // },
      // {
      //   src: "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
      // },
    ]
  },
  {
    type: "en",
    imgList: [
      {
        src:"https://www.victrum.com/image/tp/微创首页banner.png"
      }
      // {
      //   src: "/Users/liuwei/yk/img",
      // }
      // , {
      //   src: "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
      // },
      // {
      //   src: "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
      // },
    ]
  }
]



// WEBPACK FOOTER //
// ./src/components/js/image/image.js